import { memo } from 'react'
import type { ChatCard, ThreadLoad } from './cardResults'
import { InvoicesTable } from './InvoicesTable'
import { PageFooter } from './PageFooter'
import { PodPreviewCard } from './PodPreviewCard'
import { LoadsTable } from './LoadsTable'
import { InvoicePreview, LoadPreview } from './Previews'
import { WorklistCard } from './WorklistCard'
import { WriteRows } from './WriteRows'

interface ChatCardViewProps {
    card: ChatCard
    loads: ThreadLoad[]
    onSend: (message: string) => void
}

/** A card's answer in the thread (plan FR-G3), drawn by the view its card and rows call for. Drawn again only when its card (kept
 *  by id across reads), the thread's loads or the send changes, so a turn's end does not re-render every table above it. */
export const ChatCardView = memo(function ChatCardView({ card, loads, onSend }: ChatCardViewProps) {
    const { view } = card
    return (
        <section aria-label={card.card ?? 'Card result'} className="w-full max-w-[95%] self-start rounded-2xl bg-surface p-3 text-foreground shadow-surface">
            {view.view === 'invoices' && <InvoicesTable rows={view.rows} page={view.page} loads={loads} onSend={onSend} />}
            {view.view === 'invoice-preview' && (
                <div className="flex flex-col gap-2">
                    {view.invoices.map((invoice, i) => (
                        <InvoicePreview key={invoice.invoice_id ?? i} invoice={invoice} />
                    ))}
                    <PageFooter page={view.page} subject="invoices" onSend={onSend} />
                </div>
            )}
            {view.view === 'loads' && (
                <div className="flex flex-col gap-2">
                    <LoadsTable rows={view.rows} onSend={onSend} />
                    <PageFooter page={view.page} subject="loads" onSend={onSend} />
                </div>
            )}
            {view.view === 'load-preview' && <LoadPreview load={view.load} onSend={onSend} />}
            {view.view === 'writes' && <WriteRows card={view.card} rows={view.rows} onSend={onSend} />}
            {view.view === 'document' && <PodPreviewCard document={view.document} onSend={onSend} />}
            {view.view === 'worklist' && <WorklistCard worklist={view.worklist} loads={loads} onSend={onSend} />}
        </section>
    )
})
